namespace GeniuzPOS.CustomReport {
    export namespace ReportCustomerSurveyService {
        export const baseUrl = 'CustomReport/ReportCustomerSurvey';

        export declare function Create(request: Serenity.SaveRequest<ReportCustomerSurveyRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<ReportCustomerSurveyRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<ReportCustomerSurveyRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<ReportCustomerSurveyRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "CustomReport/ReportCustomerSurvey/Create",
            Update = "CustomReport/ReportCustomerSurvey/Update",
            Delete = "CustomReport/ReportCustomerSurvey/Delete",
            Retrieve = "CustomReport/ReportCustomerSurvey/Retrieve",
            List = "CustomReport/ReportCustomerSurvey/List"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List'
        ].forEach(x => {
            (<any>ReportCustomerSurveyService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
